/*
 * Copyright © 2025 Gavin Sawyer. All rights reserved.
 */

export const twilioMessagingServiceSid: string = "MGb42048a56c451bbbb3d57720ccb027ed" as string;
